import { render, staticRenderFns } from "./WaitingForGraphAuthentication.vue?vue&type=template&id=3824af8f"
import script from "./WaitingForGraphAuthentication.vue?vue&type=script&lang=js"
export * from "./WaitingForGraphAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports